import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Mensalidades.css';

function Mensalidades() {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const [alunos, setAlunos] = useState([]);
  const [selectedAluno, setSelectedAluno] = useState(null);
  const [error, setError] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const fetchAlunos = async () => {
      try {
        const { data, error } = await supabase.from('alunos').select('*');
        if (error) {
          console.error('Erro ao buscar alunos:', error);
          setError('Erro ao carregar alunos: ' + error.message);
          return;
        }
        console.log('Dados brutos do Supabase:', data);
        setAlunos(data);
      } catch (err) {
        console.error('Erro inesperado ao buscar alunos:', err);
        setError('Erro inesperado ao carregar alunos');
      }
    };
    fetchAlunos();
  }, []);

  const onSubmit = async (data) => {
    if (!selectedAluno) {
      alert('Selecione um aluno primeiro!');
      return;
    }

    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      setError('Usuário não autenticado. Por favor, faça login.');
      navigate('/login');
      return;
    }

    const mensalidade = {
      aluno_id: selectedAluno.matricula,
      aluno_nome: selectedAluno.nome,
      mes_referencia: data.mesReferencia,
      status: data.status,
      data_pagamento: data.status === 'Pago' ? data.dataPagamento : null,
    };

    const { error } = await supabase.from('mensalidades').insert([mensalidade]);
    if (error) {
      console.error('Erro ao salvar mensalidade:', error);
      setError('Erro ao salvar mensalidade: ' + error.message);
      return;
    }

    alert('Mensalidade registrada com sucesso!');
    navigate('/home');
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const selectAluno = (aluno) => {
    setSelectedAluno(aluno);
    setIsDropdownOpen(false);
    console.log('Aluno selecionado:', aluno);
  };

  return (
    <div className="mensalidades-container">
      <h1>Controle de Mensalidades</h1>
      {error && <p className="error-message">{error}</p>}
      {alunos.length === 0 ? (
        <p>Nenhum aluno cadastrado ainda.</p>
      ) : (
        <>
          <label>Selecione o Aluno:</label>
          <div className="custom-dropdown">
            <div className="dropdown-selected" onClick={toggleDropdown}>
              {selectedAluno ? (
                <div className="selected-aluno">
                  {selectedAluno.foto_url ? (
                    <img
                      src={selectedAluno.foto_url}
                      alt={selectedAluno.nome}
                      className="aluno-foto"
                      onError={() => console.log('Erro ao carregar foto:', selectedAluno.foto_url)}
                    />
                  ) : (
                    <div className="no-foto">Sem foto</div>
                  )}
                  <span>{selectedAluno.nome} - Matrícula: {selectedAluno.matricula}</span>
                </div>
              ) : (
                <span>Escolha um aluno</span>
              )}
              <span className="dropdown-arrow">{isDropdownOpen ? '▲' : '▼'}</span>
            </div>
            {isDropdownOpen && (
              <div className="dropdown-options">
                {alunos.map((aluno) => (
                  <div
                    key={aluno.matricula}
                    className="dropdown-option"
                    onClick={() => selectAluno(aluno)}
                  >
                    {aluno.foto_url ? (
                      <img
                        src={aluno.foto_url}
                        alt={aluno.nome}
                        className="aluno-foto"
                        onError={() => console.log('Erro ao carregar foto:', aluno.foto_url)}
                      />
                    ) : (
                      <div className="no-foto">Sem foto</div>
                    )}
                    <div className="aluno-info">
                      <div className="aluno-nome">{aluno.nome}</div>
                      <div>Matrícula: {aluno.matricula}</div>
                      <div>Idade: {aluno.idade || 'N/A'}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {selectedAluno && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <h3>Aluno: {selectedAluno.nome}</h3>

              <label>Mês Referência:</label>
              <input
                {...register('mesReferencia')}
                placeholder="Ex: Abril/2025"
                required
              />

              <label>Status:</label>
              <select {...register('status')} defaultValue="Pendente">
                <option value="Pendente">Pendente</option>
                <option value="Pago">Pago</option>
              </select>

              <label>Data do Pagamento (se pago):</label>
              <input {...register('dataPagamento')} type="date" />

              <button type="submit">Confirmar</button>
            </form>
          )}
        </>
      )}

      <button onClick={() => navigate('/mensalidades-pagas')}>
        Ver Mensalidades Pagas
      </button>
      <button onClick={() => navigate('/home')}>Voltar</button>
    </div>
  );
}

export default Mensalidades;